(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const postToPlayer = (iframe, type, play) => {
    if (!iframe?.contentWindow) return;
    if (type === 'youtube') {
      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: play ? 'playVideo' : 'pauseVideo',
        args: [],
      }), '*');
      return;
    }
    if (type === 'vimeo') {
      iframe.contentWindow.postMessage(JSON.stringify({ method: play ? 'play' : 'pause' }), '*');
    }
  };

  const loadIframe = (iframe, { forceAutoplay = false } = {}) => {
    if (!iframe || iframe.getAttribute('src') || !iframe.dataset.src) return;
    let src = iframe.dataset.src;
    if (forceAutoplay) {
      const url = new URL(src);
      url.searchParams.set('autoplay', '1');
      if (!url.searchParams.has('mute')) url.searchParams.set('mute', '1');
      src = url.toString();
    }
    iframe.src = src;
  };

  const pauseMedia = (root) => {
    root.querySelectorAll('[data-popup-media]').forEach((slot) => {
      const video = slot.querySelector('video');
      const iframe = slot.querySelector('iframe');
      const playBtn = slot.querySelector('[data-media-play]');
      const type = slot.dataset.videoType;
      if (video) {
        video.pause();
        const playIcon = playBtn?.querySelector('[data-icon-play]');
        const pauseIcon = playBtn?.querySelector('[data-icon-pause]');
        if (playIcon) playIcon.hidden = false;
        if (pauseIcon) pauseIcon.hidden = true;
      }
      if (iframe) postToPlayer(iframe, type, false);
    });
  };

  const bindMedia = (slot) => {
    if (!slot || slot.dataset.mediaReady === 'true') return;
    slot.dataset.mediaReady = 'true';
    if (slot.dataset.mediaType !== 'video') return;

    const video = slot.querySelector('video');
    const iframe = slot.querySelector('iframe');
    const playBtn = slot.querySelector('[data-media-play]');
    const muteBtn = slot.querySelector('[data-media-mute]');
    const poster = slot.querySelector('.popup-media__poster');
    const type = slot.dataset.videoType;
    const autoplay = slot.dataset.autoplay === 'true' && !reduceMotion;

    const setPlaying = (playing) => {
      const playIcon = playBtn?.querySelector('[data-icon-play]');
      const pauseIcon = playBtn?.querySelector('[data-icon-pause]');
      if (playIcon) playIcon.hidden = playing;
      if (pauseIcon) pauseIcon.hidden = !playing;
      if (playBtn && !pauseIcon) playBtn.hidden = playing;
      if (poster && playing) poster.hidden = true;
    };

    const play = () => {
      if (video) {
        video.play().then(() => setPlaying(true)).catch(() => {});
      }
      if (iframe) {
        loadIframe(iframe, { forceAutoplay: true });
        postToPlayer(iframe, type, true);
        setPlaying(true);
      }
    };

    const pause = () => {
      if (video) video.pause();
      if (iframe) postToPlayer(iframe, type, false);
      setPlaying(false);
    };

    if (reduceMotion && video) {
      video.removeAttribute('autoplay');
      video.pause();
    }

    playBtn?.addEventListener('click', () => {
      if (video && !video.paused) {
        pause();
        return;
      }
      play();
    });

    muteBtn?.addEventListener('click', () => {
      if (!video) return;
      video.muted = !video.muted;
      muteBtn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
      muteBtn.setAttribute(
        'aria-label',
        video.muted ? (muteBtn.dataset.unmuteLabel || 'Unmute video') : (muteBtn.dataset.muteLabel || 'Mute video')
      );
      const mutedIcon = muteBtn.querySelector('[data-icon-muted]');
      const unmutedIcon = muteBtn.querySelector('[data-icon-unmuted]');
      if (mutedIcon) mutedIcon.hidden = !video.muted;
      if (unmutedIcon) unmutedIcon.hidden = video.muted;
    });

    video?.addEventListener('play', () => setPlaying(true));
    video?.addEventListener('pause', () => setPlaying(false));

    if (autoplay) play();
  };

  document.querySelectorAll('[data-popup-events]').forEach((root) => {
    if (root.dataset.popupReady === 'true') return;
    root.dataset.popupReady = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-popup-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-popup-panel]'));

    const activate = (index) => {
      tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel, i) => {
        const selected = i === index;
        if (!selected) pauseMedia(panel);
        panel.hidden = !selected;
        if (selected) {
          panel.querySelectorAll('[data-popup-media]').forEach(bindMedia);
          panel.querySelectorAll('.js-map-lazy').forEach((placeholder) => {
            if (placeholder.dataset.bound === 'true') return;
            placeholder.dataset.bound = 'true';
            placeholder.querySelector('[data-load-map]')?.addEventListener('click', () => {
              if (typeof window.HazzaaLoadMap === 'function') {
                window.HazzaaLoadMap(placeholder);
              } else if (placeholder.dataset.src) {
                const iframe = document.createElement('iframe');
                iframe.src = placeholder.dataset.src;
                iframe.title = placeholder.querySelector('p')?.textContent || 'Map';
                iframe.loading = 'lazy';
                iframe.referrerPolicy = 'no-referrer-when-downgrade';
                iframe.setAttribute('allowfullscreen', '');
                placeholder.replaceWith(iframe);
              }
            });
          });
        }
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        activate(index);
        tab.focus();
      });

      tab.addEventListener('keydown', (event) => {
        let next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        activate(next);
        tabs[next].focus();
      });
    });

    const activeIndex = Math.max(0, tabs.findIndex((tab) => tab.classList.contains('is-active')));
    activate(activeIndex);
  });
})();
